import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/globals.css'
import App from './App.tsx'

// A deploy can replace hashed chunk filenames while a visitor's tab still
// holds the previous build in memory — the next lazy route import then 404s.
// Reload once to pick up the new build instead of showing an error.
window.addEventListener('vite:preloadError', () => {
  const key = 'aiphra:reloaded-after-preload-error';
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, '1');
  window.location.reload();
});
window.addEventListener('load', () => {
  sessionStorage.removeItem('aiphra:reloaded-after-preload-error');
  sessionStorage.removeItem('chunk-reload-attempted');
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
